<template>
  <div class="lec-home-wtxh">
    <!-- 顶部横幅区域 -->
    <div class="banner-section">
      <div class="banner-content">
        <div class="avatar-wrap">
          <img v-if="lecInfo.avatar" :src="lecInfo.avatar" class="avatar-img" />
          <img v-else src="@/assets/per_img.png" class="avatar-img" />
        </div>
        <div class="info-wrap">
          <div class="lec-name">{{ lecInfo.name }}</div>
          <div class="info-item" v-if="lecInfo.tags && lecInfo.tags.length">
            <span class="info-label">专业领域</span>
            <span class="info-value">{{ lecInfo.tags.join('、') }}</span>
          </div>
          <div class="info-item" v-if="lecInfo.teach_direction && lecInfo.teach_direction.length">
            <span class="info-label">绝技绝活</span>
            <span class="info-value">{{ lecInfo.teach_direction.join('、') }}</span>
          </div>
          <div class="info-item" v-if="lecInfo.company">
            <span class="info-label">主攻方向</span>
            <span class="info-value">{{ lecInfo.company }}</span>
          </div>
        </div>
        <div class="more-link" @click="$router.push('/lecturer')">
          <span>更多工匠人才</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <!-- 介绍区域 -->
    <div class="introduce-section" v-if="lecInfo.introduce">
      <div class="introduce-content">{{ lecInfo.introduce }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LecHomeWtxh",
  data() {
    return {
      lecId: "",
      lecInfo: "",
    };
  },
  mounted() {
    this.lecId = this.$route.params.id;
    this.getLecInfo();
  },
  methods: {
    getLecInfo() {
      this.$axios.post(`/v1/teacher/detail`, { id: this.lecId }).then((res) => {
        this.lecInfo = res.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.lec-home-wtxh {
  background-color: rgba(247, 251, 252, 1);
}
// 横幅区域
.banner-section {
  width: 100%;
  height: 523px;
  background: url('~@/assets/wtxh/lecturer_banner_bg.png') no-repeat center center;
  background-size: cover;
}
.banner-content {
  width: 1188px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  position: relative;
}
.avatar-wrap {
  width: 286px;
  height: 386px;
  flex-shrink: 0;
  overflow: hidden;
}
.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.info-wrap {
  margin-left: 100px;
  flex: 1;
}
.lec-name {
  font-size: 40px;
  font-family: PingFang-SC-Heavy, "PingFang SC", sans-serif;
  font-weight: 600;
  color: #fff;
  line-height: 56px;
  margin-bottom: 30px;
}
.info-item {
  margin-bottom: 11px;
  visibility: hidden;
  &:last-child {
    margin-bottom: 0;
  }
}
.info-label {
  display: block;
  font-size: 18px;
  font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
  font-weight: 500;
  color: rgba(238, 238, 238, 1);
  line-height: 25px;
  margin-bottom: 11px;
}
.info-item + .info-item {
  margin-top: 30px;
}
.info-value {
  display: block;
  font-size: 16px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  font-weight: normal;
  color: rgba(238, 238, 238, 1);
  line-height: 22px;
}
.more-link {
  position: absolute;
  right: 0;
  top: 102px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 154px;
  height: 36px;
  border-radius: 18px;
  border: 1px solid rgba(151, 151, 151, 0.57);
  cursor: pointer;
  transition: all 0.2s;
  span {
    font-size: 16px;
    font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
    color: rgba(238, 238, 238, 1);
    line-height: 22px;
  }
  i {
    font-size: 12px;
    color: rgba(238, 238, 238, 1);
    margin-left: 6px;
  }
  &:hover {
    border-color: #fff;
    span, i {
      color: #fff;
    }
  }
}
// 介绍区域
.introduce-section {
  width: 1188px;
  margin: 0 auto;
  padding: 71px 0;
}
.introduce-content {
  font-size: 18px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  font-weight: normal;
  color: rgba(108, 110, 116, 1);
  line-height: 40px;
  text-align: justify;
}
</style>
